import { Flex, Text } from "@chakra-ui/react";
import { useAppContext } from "../AppContext";
import { BookSVG } from "../svg/BookSVG";
import { LineByLineSVG } from "../svg/LineByLineSVG";
import { baseStyles, darkThemeStyles } from "./selectorStyles";
import Select, { components } from "react-select";
import React from "react";

export const ViewMode = (): JSX.Element => {
  const { viewMode, setViewMode, colorMode, isEnglish } = useAppContext();
  const isCombined = viewMode === "combined";

  const iconColor = colorMode === "dark" ? "#fff" : "#000";

  // Custom SingleValue Component
  const CustomSingleValue = (props: any) => {
    return (
      <components.SingleValue {...props}>
        <Flex align="center">
          {React.cloneElement(props.data.icon, { color: iconColor })}
          <Text ml={2}>{props.data.label}</Text>
        </Flex>
      </components.SingleValue>
    );
  };

  const formatOptionLabel = ({ label, icon }: any) => (
    <Flex align="center">
      {React.cloneElement(icon, { color: iconColor })}
      <Text ml={2}>{label}</Text>
    </Flex>
  );

  const options = [
    { value: "combined", label: `${isEnglish ? "Paragraph" : "段落"}`, icon: <BookSVG /> },
    { value: "versus", label: `${isEnglish ? "Line by line" : "逐行"}`, icon: <LineByLineSVG /> },
  ];

  const handleSelect = (selectedOption: any) => {
    setViewMode(selectedOption.value);
  };

  return (
    <Flex align="center" justify="space-between">
      <Text fontSize={"lg"} as="b">
        {isEnglish ? `View Mode:` : "排版："}
      </Text>
      <div style={{ width: "200px" }}>
        <Select
          options={options}
          onChange={handleSelect}
          isSearchable={false}
          defaultValue={isCombined ? options[0] : options[1]}
          styles={{
            ...baseStyles,
            ...(colorMode === "dark" ? darkThemeStyles : {}),
            // You can include light theme styles here as well, if needed
          }}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          components={{
            SingleValue: CustomSingleValue,
          }}
          formatOptionLabel={formatOptionLabel}
        />
      </div>
    </Flex>
  );
};
